import { readCookie } from "common/utils/cookie";
import initVueProductDetailsDtf from "components/jiffy/vue-product-details-dtf/vue-product-details-dtf";
import { initApp } from "components/jiffy/jiffy-services-preview/jiffy-services-preview";
import "./product-details-dtf-features/product-details-dtf-features";
import "./product-details-dtf-extras/product-details-dtf-extras";
import "./product-details-bulk-buyer-modal/product-details-bulk-buyer-modal";
import "./product-details-dtf-sheet.scss";

const $getProductPageContainer = () => document.getElementById("product-page-container");
const $getRoot = () => document.querySelector(".js-product-details-dtf-sheet");

export default async () => {
  if (!$getRoot()) return;

  $getProductPageContainer().classList.add("product-details__container--dtf");
  initVueProductDetailsDtf();
  initApp(".js-upsell-container");

  const artworkIds = readCookie("uploaded_artwork_ids");

  if (!artworkIds) {
    return;
  }

  const rootRect = $getRoot().getBoundingClientRect();
  const absoluteElementTop = rootRect.top + window.scrollY;

  window.scrollTo({
    top: absoluteElementTop,
    behavior: "smooth"
  });
};
